import { NgModule } from '@angular/core';
import { Routes, RouterModule, CanActivate } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MentionComponent } from './mention/mention.component';
import { AnalysisComponent } from './analysis/analysis.component'; 
import { SourceComponent } from './source/source.component';
import { QuotesComponent } from './quotes/quotes.component';
import { CompareComponent } from './compare/compare.component';
import { AddprojectComponent } from './addproject/addproject.component';
import { ProjectsComponent } from './projects/projects.component';
import { AddComponent as AddProject } from './projects/add/add.component';
import { EditComponent as EditProject } from './projects/edit/edit.component';
import { EmailreportComponent } from './emailreport/emailreport.component';
import { ExcelReportComponent } from './excel-report/excel-report.component';
import { PdfreportComponent } from './pdfreport/pdfreport.component';
import { InfographComponent } from './infograph/infograph.component';
import { UsersComponent } from './users/users.component';
import { AddComponent } from './users/add/add.component';
import { EditComponent } from './users/edit/edit.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LogsComponent } from './logs/logs.component';
import { LoginFailuresComponent } from './login-failures/login-failures.component';

import { LoginService } from './services/login.service';
import { DashboardService } from './services/dashboard.service';

import { RequestsComponent } from './keywords/requests/requests.component';
import { ResponseComponent } from './keywords/response/response.component';

const routes: Routes = [
    { path: '', component: LoginComponent, canActivate: [DashboardService] },  
    { path: 'login', component: LoginComponent, canActivate: [DashboardService] },  
    { path: 'register-account', component: SignupComponent, canActivate: [DashboardService] },  
    { path: 'activities', component: LogsComponent, canActivate: [LoginService] },  
    { path: 'dashboard', component: DashboardComponent, canActivate: [LoginService] },  
    { path: 'mention', component: MentionComponent, canActivate: [LoginService] }, 
    { path: 'analysis', component: AnalysisComponent, canActivate: [LoginService] },
    { path: 'source', component: SourceComponent, canActivate: [LoginService] },  
    { path: 'quotes', component: QuotesComponent, canActivate: [LoginService] }, 
    { path: 'compare', component: CompareComponent, canActivate: [LoginService] },
    { path: 'projects', component: ProjectsComponent, canActivate: [LoginService] },
    { path: 'projects/add', component: AddProject, canActivate: [LoginService] },
    { path: 'projects/edit/:id', component: EditProject, canActivate: [LoginService] },
    { path: 'emailreport', component: EmailreportComponent, canActivate: [LoginService] },
    { path: 'pdfreport', component: PdfreportComponent, canActivate: [LoginService] },
    { path: 'users', component: UsersComponent, canActivate: [LoginService] },
    { path: 'users/add', component: AddComponent, canActivate: [LoginService] },
    { path: 'users/edit/:id', component: EditComponent, canActivate: [LoginService] },
    { path: 'infographic', component: InfographComponent, canActivate: [LoginService] },
    { path: 'excel-report', component: ExcelReportComponent, canActivate: [LoginService] },
    { path: 'change-password', component: ChangePasswordComponent, canActivate: [LoginService] },
    { path: 'login-failures', component: LoginFailuresComponent, canActivate: [LoginService] },
    { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [DashboardService] },
    { path: 'keywords/requests', component: RequestsComponent, canActivate: [LoginService] }, 
    { path: 'keywords/response', component: ResponseComponent, canActivate: [LoginService] }, 
    { path: '**', component: NotFoundComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
